import React from 'react';
import { Modal } from 'antd';
import {
  Container
} from './styles';
import CreateFlowTemplate from './CreateFlowTemplate';
import { withTranslation } from 'react-i18next';
import { CREATE_FLOW_MODAL } from './translationValues';

const CreateFlowModal = props => {
  const { onSucess ,onCancel , t , flow} = props;
  return (
    <Container onKeyDown={e => e.stopPropagation()}>
      <Modal
        title={t(CREATE_FLOW_MODAL.CREATE_REUSABLE_PAGE_TITLE.key, CREATE_FLOW_MODAL.CREATE_REUSABLE_PAGE_TITLE.value) }
        centered
        maskClosable={false}
        visible={true}
        width="625px"       
        footer={false}
        className="warning-modal"
        onCancel={onCancel}
      >
        <CreateFlowTemplate onSucess={onSucess} flow={flow}/>
      </Modal>
    </Container>
  );
};
export default withTranslation(["CREATE_FLOW_MODAL"])(CreateFlowModal);

